import Ajv from 'ajv'

import { extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

import Configuration from './Configuration.js'

export default {
    created() {
        const validator = new Ajv({
            unknownFormats: Configuration.get('validation.unknownFormats', []),
            coerceTypes: true,
            nullable: true
        })

        extend('match', {
            validate(value, parameters) {
                var val = value
                if (parameters.schema.format == "double") {
                    val = parseFloat(`${val}`.replace(/,/g, "."))
                }
                // Nasty hack to make select-type parameters (`{ type: string, enum: [...] }`) with allOf in their spec work
                if (parameters.schema.type === "object" && parameters.schema.enum) {
                    parameters.schema.type = "string";
                }
                const result = validator.validate(parameters.schema, val)
                return result
            },
            params: ['schema']
        })

        extend('required', required)
    }
}